<template>
	<div class="content">
		<div v-if="loading" class="text-center pt-24-c">
			<Loader size_prop="10em"></Loader>
		</div>

		<template v-else>

			<!-- Navbar -->
			<nav class="navbar navbar-expand-lg navbar-absolute navbar-transparent fixed-top">
				<div class="container-fluid">
					<!-- <div class="navbar-wrapper">
					<div class="navbar-toggle d-inline">
						<button type="button" class="navbar-toggler">
							<span class="navbar-toggler-bar bar1"></span>
							<span class="navbar-toggler-bar bar2"></span>
							<span class="navbar-toggler-bar bar3"></span>
						</button>
					</div>
					<a class="navbar-brand" href="#">Login Page</a>
				</div>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
				</button>
				<div class="collapse navbar-collapse" id="navigation">
					<ul class="navbar-nav ml-auto">
						<li class="nav-item">
							
						</li>
						<li class="nav-item ">
							<a href="register.html" class="nav-link">
								<i class="tim-icons icon-laptop"></i> Register
							</a>
						</li>
						<li class="nav-item ">
							<a href="login.html" class="nav-link">
								<i class="tim-icons icon-single-02"></i> Login
							</a>
						</li>
						<li class="nav-item	active ">
							<a href="pricing.html" class="nav-link">
								<i class="tim-icons icon-coins"></i> Pricing
							</a>
						</li>
						<li class="nav-item ">
							<a href="lock.html" class="nav-link">
								<i class="tim-icons icon-lock-circle"></i> Lock
							</a>
						</li>
					</ul>
				</div> -->
				</div>
			</nav>
			<!-- <div class="modal modal-search fade" id="searchModal" tabindex="-1" role="dialog" aria-labelledby="searchModal" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<input type="text" class="form-control" id="inlineFormInputGroup" placeholder="SEARCH">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<i class="tim-icons icon-simple-remove"></i>
						</button>
					</div>
				</div>
			</div>
		</div> -->
			<!-- End Navbar -->

			<div class="wrapper wrapper-full-page ">
				<div class="full-page login-page ">
					<!--	 you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
					<div class="content pt-5">
						<div class="w-100 text-center mb-28-c">
							<img class="mb-16-c" style="width: 20em;" :src="`${publicPath}assets/img/jfxgoldx.png`" alt="">
							<div class=""><span class="text-title">Platform Perdagangan Fisik Emas Dalam Bursa Pertama di
									Indonesia</span>
							</div>
						</div>
						<div class="container">
							<div class="col-lg-4 col-md-6 ml-auto mr-auto">
								<!-- Login -->
								<form v-if="formType == 'login'" class="form" @submit.prevent="login">
									<div class="card">
										<div class="card-header">
											<h1 class="card-title">Log in</h1>
										</div>
										<div class="card-body">
											<label for="userId">Email / Username / Phone</label>
											<div class="input-group-c mb-16-c">
												<div class="input-group-prepend-c">
													<div class="">
														<i class="tim-icons icon-single-02"></i>
													</div>
												</div>
												<input type="text" class="" name="userId" placeholder="Masukkan Email / Username / Phone"
													v-model="userId" required autofocus>
											</div>

											<label for="password">Password</label>
											<div class="input-group-c mb-16-c">
												<div class="input-group-prepend-c">
													<div class="input-group-text-c">
														<i class="tim-icons icon-lock-circle"></i>
													</div>
												</div>

												<input v-if="!showPassword" type="password" class="" name="password"
													placeholder="Masukkan Password" v-model="password" autocomplete="off" required>
												<input v-else type="text" class="" name="password" placeholder="Password" v-model="password"
													autocomplete="off" required>

												<div class="input-group-append-c cursor-hover-pointer" @click="tooglePassword"
													:title="showPassword ? 'Hide Password' : 'Show Password'">
													<span class="input-group-text-c">{{ showPassword ? '&#x2298;' : '&#x229A;' }} </span>
												</div>
											</div>

											<label for="perantaraPerdagangan">Perantara Perdagangan</label>
											<div class="input-group-c">
												<select class="" id="perantaraPerdagangan" v-model="perantaraPerdagangan">
													<option value="MetalGo">ABI KB -
														MetalGO</option>
													<option value="PosPayGold">ABI KB -
														PospayGold</option>
												</select>
											</div>

										</div>
										<div class="card-footer">
											<button type="submit" class="btn c-btn-theme btn-lg btn-block mb-24-c"
												:disabled="this.$store.state.status == 'loading' ? true : false">
												Login
											</button>

											<small class="form-text text-center" @click="changeFormType('basicRegister')">
												<span class="color-gold-c c-text-theme-hoverable  cursor-hover-pointer">
													Don't have demo account?
													<b>Create demo account</b>
												</span>
											</small>

											<div class="pull-left">
												<h6>
													<!-- <a href="#" class="link footer-link">Create Account</a> -->
												</h6>
											</div>
											<div class="text-center">
												<h6 v-if=response class="color-red-c mt-2">{{ response }}
													<!-- <a href="#" class="link footer-link">Need Help?</a> -->
												</h6>
											</div>
										</div>
									</div>
								</form>

								<!-- Forgot Password -->
								<form v-else-if="formType == 'basicRegister'" class="form" @submit.prevent="basicRegister">
									<div class="card">
										<div class="card-header">
											<h1 class="card-title">Register Demo</h1>
										</div>
										<div class="card-body pb-0">
											<!-- <div class="mb-2">We will send a link to your Email</div> -->

											<label for="nameBasicRegister">Username</label>
											<div class="input-group-c mb-16-c">
												<div class="input-group-prepend-c">
													<div class="">
														<i class="tim-icons icon-single-02"></i>
													</div>
												</div>
												<input type="text" id="nameBasicRegister" class="" name="nameBasicRegister"
													placeholder="Enter your name" v-model="nameBasicRegister" autofocus>
											</div>

											<label for="emailBasicRegister">Email</label>
											<div class="input-group-c mb-16-c">
												<div class="input-group-prepend-c">
													<div class="">
														<i class="tim-icons icon-email-85"></i>
													</div>
												</div>
												<input type="email" id="emailBasicRegister" class="" name="emailBasicRegister"
													placeholder="Enter your email" v-model="emailBasicRegister">
											</div>

											<label for="phoneBasicRegister">Phone</label>
											<div class="input-group-c mb-16-c">
												<div class="input-group-prepend-c">
													<div class="">
														<i class="tim-icons icon-mobile"></i>
													</div>
												</div>
												<input type="text" id="phoneBasicRegister" class="" name="phoneBasicRegister"
													placeholder="Enter your phone number" v-model="phoneBasicRegister">
											</div>

										</div>
										<div class="card-footer">
											<button type="submit" class="btn c-btn-theme btn-lg btn-block mb-24-c"
												:disabled="basicRegisterApiStatus == 'loading' ? true : false">Submit</button>

											<small class="form-text text-center" @click="changeFormType('login')">
												<span class="color-gold-c c-text-theme-hoverable  cursor-hover-pointer">Back to
													<b>Login</b>
												</span>
											</small>

											<div class="text-center">
												<h6 v-if="responseBasicRegister" class="color-red-c">
													{{ responseBasicRegister }}
													<!-- <a href="#" class="link footer-link">Need Help?</a> -->
												</h6>
											</div>

										</div>
									</div>
								</form>
							</div>
						</div>
						<div class="w-100 text-center">
							<div class="lable-icon">Organized by</div>
							<img class="mb-3" style="width: 10em; margin-right:25px;" :src="`${publicPath}assets/img/logo-jfx-bw.png`"
								alt="">
							<img class="mb-3" style="width: 8em; margin-right:25px;" :src="`${publicPath}assets/img/logo-kbi-bw.png`"
								alt="">
							<img class="mb-3" style="width: 5em; margin-right:25px;" :src="`${publicPath}logo_pos_bw.png`" alt="">
						</div>
					</div>
					<Footer></Footer>
				</div>
			</div>

		</template>

	</div>
</template>

<script>
import axios from '@/api/axios.js'
// import Swal from 'sweetalert2'

import Loader from '@/components/Loader.vue'

import Footer from '@/components/layout/Footer.vue'

export default {
	name: 'Login',
	components: {
		Loader,

		Footer
	},
	data() {
		return {
			publicPath: process.env.BASE_URL,

			userId: '',
			password: '',
			perantaraPerdagangan: 'MetalGo',

			formType: 'login',

			nameBasicRegister: '',
			emailBasicRegister: '',
			phoneBasicRegister: '',

			basicRegisterApiStatus: 'idle',
			responseBasicRegister: '',

			showPassword: false,

			loading: true,
		}
	},
	computed: {
		response() {
			let response = this.$store.state.status
			if (response) {
				return response
			} else {
				return null
			}
		}
	},

	created() {
		if (this.$route.query.status == 'logout') {
			// PosPayGold || NUNomics || BMTDigi || AGIGold
			if (this.$store.state.instantLogin) {
				this.$store.commit('setInstantLogin_mut', false)
				this.backToApp('normalLogout')
			}
		}

		this.$store.commit('setInstantLogin_mut', false) // instantLogin always false initially

		this.script = document.createElement('script')

		this.script.src = "https://www.google.com/recaptcha/enterprise.js?render=" + this.$store.state.captchaSiteKey
		this.script.async = true

		document.body.appendChild(this.script)

		const app = this.$route.query.app
		this.$store.commit('setApp_mut', app)

		if (this.$route.query.name && this.$route.query.email && this.$route.query.phoneNumber) {
			this.$store.commit('setInstantLogin_mut', true)
			this.instantLogin()
		} else {
			this.loading = false
		}

	},

	destroyed() {
		document.body.removeChild(this.script)
	},

	methods: {
		tooglePassword() {
			this.showPassword = !this.showPassword
		},

		login() {
			const { userId, password, perantaraPerdagangan } = this
			this.$store.dispatch('getGeolocation')
				.then((geolocation) => {
					if (!geolocation.hasOwnProperty('latitude') || !geolocation.hasOwnProperty('longitude') || !geolocation.hasOwnProperty('city') || !geolocation.hasOwnProperty('region') || !geolocation.hasOwnProperty('country') || !geolocation.hasOwnProperty('userIP')) {
						this.$store.commit('AUTH_ERROR', "Unable to Login. Please check your connection.")
						throw ('')
					}

					this.$store.dispatch('checkFormatAuth', { userId, password })
						.then((user1) => {
							this.$store.dispatch('checkUser', user1)
								.then((responseCheckUser) => {
									this.$store.dispatch('AUTH_REQUEST', [responseCheckUser.is_status, { ...user1, app_name: perantaraPerdagangan }])
										.then((user) => {
											this.$store.dispatch('setTokenDemo', user)
												.then(() => {
													this.$store.dispatch('setAccountInformation')
														.then(() => {
															localStorage.setItem('token', this.$store.state.token)

															// for login expired in frontend only
															localStorage.setItem('loginExpiredTime', Date.now() + this.$store.state.loginExpiredTimeState)

															// for refresh token
															// localStorage.setItem('refreshTokenTime', Date.now() + this.$store.state.refreshTokenTimeState)

															localStorage.setItem('demoAccountId', this.$store.state.demoAccountId)

															localStorage.setItem('account', JSON.stringify(this.$store.state.account))

															this.$store.commit('AUTH_CHANGE_STATUS', 'success')

															const temp = JSON.parse(localStorage.getItem('nextUrl'))
															if (temp) {
																localStorage.removeItem('nextUrl')
																window.location.href = temp
																// this.$router.push(temp)
																// .then(() => {
																// }).catch(() => {
																// })
															} else {
																window.location.href = '/'
																// this.$router.push('/')
																// .then(() => {
																// }).catch(() => {
																// })
															}
														})
														.catch(() => { })
												})
												.catch(() => { })
										})
										.catch(() => { })
								})
								.catch(() => { })
						})
						.catch(() => { })
				})
				.catch(() => { })
		},

		changeFormType(formType) {
			this.formType = formType
		},

		basicRegister() {
			this.setBasicRegister()
				.then(() => {
					this.$store.dispatch('setAccountInformation')
						.then(() => {
							this.responseBasicRegister = 'success'

							localStorage.setItem('token', this.$store.state.token)

							// for login expired in frontend only
							localStorage.setItem('loginExpiredTime', Date.now() + this.$store.state.loginExpiredTimeState)

							// for refresh token
							localStorage.setItem('refreshTokenTime', Date.now() + this.$store.state.refreshTokenTimeState)

							localStorage.setItem('demoAccountId', this.$store.state.demoAccountId)
							localStorage.setItem('demoToken', this.$store.state.demoToken)

							const temp = JSON.parse(localStorage.getItem('nextUrl'))
							if (temp) {
								localStorage.removeItem('nextUrl')
								this.$router.push(temp)
									.then(() => {
										// console.log('then atas')
									}).catch(() => {
										// console.log('catch atas', err.config)
									})
							} else {
								this.$router.push('/')
									.then(() => {

										// console.log('then bawah')
									}).catch(() => {

										// console.log('catch bawah')
									})
							}
						})
						.catch(() => { })
				})
				.catch(() => { })
		},

		setBasicRegister() {
			this.basicRegisterApiStatus = 'loading'
			this.responseBasicRegister = 'loading'

			return new Promise((resolve, reject) => {
				axios.post('/demo-abx/account/create',
					{
						name: this.nameBasicRegister,
						email: this.emailBasicRegister,
						phone: this.phoneBasicRegister,
					}
				).then(response => {
					const demoData = response.data.data

					// this.$store.commit('SET_DEMO_ACCOUNT', demoData)
					this.$store.commit('SET_DEMO_ACCOUNT_ID', demoData)

					this.$store.commit('SET_TOKEN', demoData.sessionKey)

					axios.defaults.headers.common['Authorization'] = 'Bearer ' + demoData.sessionKey

					this.basicRegisterApiStatus = 'success'

					console.log('Berhasil basic register', response)

					resolve(response)
				}).catch(error => {
					this.basicRegisterApiStatus = 'error'

					if (error.response) {
						/*
						 * The request was made and the server responded with a
						 * status code that falls out of the range of 2xx
						 */

						this.responseBasicRegister = error.response.data.message

						if ((error.response.data.data || {}).error) {
							this.responseBasicRegister = error.response.data.data.error[0].msg.message

							return
						}
					} else if (error.request) {
						/*
						 * The request was made but no response was received, `error.request`
						 * is an instance of XMLHttpRequest in the browser and an instance
						 * of http.ClientRequest in Node.js
						 */

						this.responseBasicRegister = 'Server appears to be offline'
					}

					reject(error)
				})
			})
		},

		instantLogin() {
			this.nameBasicRegister = this.$route.query.name
			this.emailBasicRegister = this.$route.query.email
			this.phoneBasicRegister = this.$route.query.phoneNumber

			this.$store.commit('setAppName_mut', this.$route.query.appName)

			this.basicRegister()
		},

		backToApp(message = 'Login Failed') { // normalLogout
			if (message == 'Login Failed') {
				window.alert(message)
			}
			window.webkit.messageHandlers.logout.postMessage('logout')
		},

		loginFromApp() {
			const tokenApp = this.$route.query.token
			const lastRefresh = this.$route.query.lastTime

			if (this.$route.query.name && this.$route.query.email && this.$route.query.phoneNumber && tokenApp && lastRefresh) {
				const nextRefresh = 210000 + lastRefresh


				this.$store.commit('setTokenMetalgo_mut', tokenApp)
				this.$store.commit('setRefreshTokenTimeMetalgo_mut', nextRefresh)

				this.instantLogin()
				this.test = 'after in up'
			} else {
				this.backToApp()
			}
		}

		// checkCreds() {
		// 	const { userId, password } = this

		// 	axios({
		// 		method: 'post',
		// 		url: process.env.VUE_APP_BACKEND_URL+'/user/login',
		// 		data: {
		// 			userId,
		// 			password
		// 		}
		// 		// responseType: 'stream'
		// 	}).then(function (response) {
		// 		// response.data.pipe(fs.createWriteStream('ada_lovelace.jpg'))
		// 		var data = response.data

		// 		 // Setting user in the state and caching record to the localStorage 
		// 		console.log(data.status)
		// 		if (data.status == 200) {
		// 			var token = data.data.token

		// 			if (window.localStorage) {
		// 				window.localStorage.setItem('token', token)
		// 			}

		// 			store.dispatch('setToken', token)
		// 		}
		// 	}).then(response => {
		// 		console.log("Berhasil")
		// 		console.log(response)
		// 		console.log(router)
		// 		router.push({name: 'Trade'})
		// 	}).catch(error => {
		// 		console.log("gagal", error)
		// 		// let data = error.response.data
		// 		// this.response = data.message
		// 	})

		// 	// Making API call to authenticate a user 
		// 	// api
		// 	//	 .request('post', '/user/login', { 
		// 	//		 data: {
		// 	//			 email,
		// 	//			 password 
		// 	//		 }
		// 	//	 })
		// 	//	 .then(response => {
		// 	//		 this.toggleLoading()
		// 	//		 console.log(response.data, response.data.status)
		// 	//		 var data = response.data

		// 	//			// Setting user in the state and caching record to the localStorage 
		// 	//		 console.log(data.status)
		// 	//		 if (data.status == 200) {
		// 	//			 var token = data.data.token

		// 	//			 if (window.localStorage) {
		// 	//				 window.localStorage.setItem('token', token)
		// 	//			 }

		// 	//			 this.$store.dispatch('setToken', token)
		// 	//		 }
		// 	//	 })
		// 	//	 .then(response => {
		// 	//		 this.$router.push({path: '/'})
		// 	//	 })
		// 	//	 .catch(error => {
		// 	//		 this.$store.commit('TOGGLE_LOADING')
		// 	//		 let data = error.response.data

		// 	//		 this.response = data.message
		// 	//		 this.toggleLoading()
		// 	//	 })
		// }
	}
}
</script>

<style scoped>
.input-group-prepend,
.input-group-append,
.input-group-append>* {
	background-color: white !important;
	border-color: #d1d3d7 !important;
}

.input-group-text {
	background-color: white;
}

.input-group-append>* {
	color: #9E9E9E;
	font-size: 1.1rem;
}

.lable-icon {
	font-size: 13px;
	color: #9E9E9E;
	margin-bottom: 20px;
}

.full-page>.content {
	padding-top: 60px;
	padding-bottom: 50px;
}

.text-title {
	display: inline-block;
	max-width: 40ch;
	text-align: center;
	font-size: 0.75rem;
	color: white;
	font-weight: 400;
}
</style>
